(function () {
    function openDrawer(id) {
        const drawer = document.getElementById(id);
        if (drawer) {
            drawer.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeDrawer(drawer) {
        if (drawer) {
            drawer.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    }

    function initProductDrawers() {
        document.addEventListener('click', (e) => {
            // Opening
            const trigger = e.target.closest('[data-drawer-trigger]');
            if (trigger) {
                const targetId = `${trigger.dataset.drawerTrigger}-drawer`;
                openDrawer(targetId);
                return;
            }

            // Closing from close buttons
            const closeBtn = e.target.closest('[data-drawer-close]');
            if (closeBtn) {
                const drawer = closeBtn.closest('.product-drawer');
                closeDrawer(drawer);
                return;
            }

            // Closing from overlay
            if (e.target.matches('.feedback-drawer__overlay')) {
                const drawer = e.target.closest('.product-drawer');
                closeDrawer(drawer);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const openDrawerEl = document.querySelector('.product-drawer.is-open');
                closeDrawer(openDrawerEl);
            }
        });
    }

    // Run once on load
    initProductDrawers();
})();

